import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { formatDate } from '../../../../../shared/utils/date';
import { formatSupplier } from '../../../../../shared/utils/run';

const getSupplier = manifestGroup => {
    const manifest = manifestGroup.manifests[0].manifest;

    return formatSupplier({
        supplierCode: manifest.supplierCode,
        supplierPlantCode: manifest.supplierPlantCode,
    });
};

const CollectionSelectionInfo = ({
    manifestGroup,
    collectionDate,
    onDateChange,
    isLoadingCollectionRoutes,
    collectionRoutes,
    onCollectionRouteChange,
    selectedCollectionRunId,
    resetCollectionSelection,
}) => (
    <Row style={{ marginBottom: 20 }}>
        <Col sm={1} style={{ textAlign: 'right' }}>
            <ControlLabel style={{ marginTop: 10 }}>Collection Date</ControlLabel>
        </Col>
        <Col sm={2}>
            <Datetime
                value={collectionDate}
                timeFormat={false}
                dateFormat="DD-MM-YYYY"
                onChange={onDateChange}
                closeOnSelect
            />
        </Col>
        <Col sm={1} style={{ textAlign: 'right' }}>
            <ControlLabel style={{ marginTop: 10 }}>Collection Route</ControlLabel>
        </Col>
        <Col sm={2}>
            {isLoadingCollectionRoutes ? (
                <p style={{ marginTop: 10 }}>Loading...</p>
            ) : (
                <FormControl
                    value={selectedCollectionRunId}
                    componentClass="select"
                    placeholder="select"
                    onChange={onCollectionRouteChange}
                >
                    <option value="">Select collection route</option>
                    {collectionRoutes.map(collectionRoute => (
                        <option key={collectionRoute.runId} value={collectionRoute.runId}>
                            {`${collectionRoute.routeCode} -
                                ${formatDate(collectionRoute.runDate)} -
                                ${collectionRoute.runSequence}`}
                        </option>
                    ))}
                </FormControl>
            )}
        </Col>
        <Col sm={1}>
            <Button onClick={resetCollectionSelection}>Reset</Button>
        </Col>
        <Col style={{ textAlign: 'center' }}>
            <ControlLabel style={{ marginTop: 10, paddingRight: 5 }}>Supplier:</ControlLabel>
            <span style={{ paddingRight: 40 }}>{getSupplier(manifestGroup)}</span>
            <ControlLabel style={{ marginTop: 10, paddingRight: 5 }}>EMC Dock:</ControlLabel>
            <span>{manifestGroup.manifests[0].manifest.emcDockCode}</span>
        </Col>
    </Row>
);

CollectionSelectionInfo.propTypes = {
    handleCollectionDateChange: PropTypes.func,
};
CollectionSelectionInfo.defaultProps = {};

export default CollectionSelectionInfo;
